module.exports = __webpack_public_path__ + "img/spei.3d1f6eb9.svg";